import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResult } from '@enterprise/types';

import { Uri } from '#constants/uri';

/**
 * Reverts a mailing by its unique identifier.
 *
 * Sends a PUT request to the mailing revert endpoint using the provided KyInstance and mailing ID.
 *
 * @param instance - The KyInstance used to make the HTTP request.
 * @param mailingId - The unique identifier of the mailing to revert.
 * @returns A promise that resolves to an OperationResult indicating the outcome of the revert operation.
 * @throws Will throw an error if the HTTP request fails.
 */
export const revertMailingById = async (instance: KyInstance, mailingId: number) => {
  try {
    return await instance.put<OperationResult>(formatString(Uri.mailing.revertById, mailingId.toString())).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
